/**
 * 글자 크기 (2026-08-05) — 노안 대응.
 *
 * 이 앱은 `html { font-size: 10px }` 고정이라 1rem = 10px 이다. 즉 폰의 "큰 글자"
 * 설정을 따라가지 않는다(`-webkit-text-size-adjust: none` 도 걸려 있다). 그래서
 * 앱 안에서 직접 고를 수 있게 한다.
 *
 * 루트 font-size 만 바꾸면 rem 으로 짠 글자·여백·버튼이 **비율 그대로** 함께 커진다.
 * 화면 높이는 안 늘어나므로 배율이 커질수록 한 화면에 담기는 양이 줄고 스크롤이 생긴다.
 * 그래서 단계를 3개로 제한하고 최대 +30% 까지만 둔다.
 *
 * 기본값은 "보통"(10px) — 기존 사용자에게는 아무 변화가 없다.
 */
export type FontScale = "normal" | "large" | "xlarge";

const KEY = "brainycards.fontScale";

/** 루트 font-size(px). 1rem 이 이 값이 된다. */
export const SCALE_PX: Record<FontScale, number> = {
  normal: 10, // 지금 그대로. 메뉴 1.4rem = 14px
  large: 11.5, // 메뉴 16.1px — iOS 목록(17px)·안드로이드(16sp) 표준에 근접
  xlarge: 13, // 메뉴 18.2px — 노안 대응
};

export const FONT_SCALES: FontScale[] = ["normal", "large", "xlarge"];

export function getFontScale(): FontScale {
  try {
    const v = window.localStorage.getItem(KEY);
    if (v === "large" || v === "xlarge" || v === "normal") return v;
  } catch {
    /* no-op */
  }
  return "normal";
}

/** 루트에 즉시 반영. 저장은 하지 않는다(미리보기용). */
export function applyFontScale(scale: FontScale): void {
  try {
    document.documentElement.style.fontSize = `${SCALE_PX[scale]}px`;
  } catch {
    /* no-op */
  }
}

export function setFontScale(scale: FontScale): void {
  try {
    window.localStorage.setItem(KEY, scale);
  } catch {
    /* no-op */
  }
  applyFontScale(scale);
}

/**
 * 앱 부팅 시 1회. index.tsx 에서 렌더 전에 부른다.
 * 렌더 후에 부르면 기본 크기로 한 번 그려졌다가 커지면서 깜빡인다.
 */
export function initFontScale(): void {
  applyFontScale(getFontScale());
}
